import { render, staticRenderFns } from "./PowerFewShotView.vue?vue&type=template&id=80764a64&scoped=true"
import script from "./PowerFewShotView.vue?vue&type=script&lang=js"
export * from "./PowerFewShotView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80764a64",
  null
  
)

export default component.exports